export default __webpack_public_path__ + "static/media/partner_logo_10.66a29643.png";